/**
 * User: daletan
 * Date: 12/15/14
 * Time: 2:31 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var SV = require('server-vars');
var verticals = require('dibs-vertical-helpers');

module.exports = function baseDomain(loc) {
    var regexp;
    var pattern;
    if (SV.settings && SV.settings.domains && !loc) {
        return SV.settings.domains.base === '1stdibs.com' ? 'www.' + SV.settings.domains.base : SV.settings.domains.base;
    } else {
        loc = loc || window.location.hostname;
        pattern = [verticals.VERTICAL_ART, verticals.VERTICAL_FASHION, verticals.VERTICAL_JEWELRY, 'realestate.'].join('.|');
        regexp = new RegExp(pattern);
        return loc.replace(regexp, '', loc);
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/utils/baseDomain.js
// module id = 2027
// module chunks = 64